var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 24,
    viewBox: "0 0 36 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 23.7043H4.17526L6.06186 17.577H14.366L16.2526 23.7043H20.4433L12.4639 0H7.97938L0 23.7043ZM10.1753 4.22177H10.268L13.3608 14.308H7.06701L10.1753 4.22177Z",
    fill: "#636363"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1237 24C29.2887 24 31.1134 22.8501 32.0567 21.0267H32.1495V23.7043H36V11.729C36 8.22998 33.3557 5.93018 29.2577 5.93018C25.0979 5.93018 22.5773 8.24641 22.3454 11.3347L22.3299 11.5318H25.9021L25.933 11.384C26.1804 10.1027 27.2938 9.19918 29.1186 9.19918C31.067 9.19918 32.1495 10.2669 32.1495 12.0246V13.2238L27.866 13.5031C23.8918 13.7659 21.634 15.6222 21.634 18.7105V18.7433C21.634 21.848 23.8454 24 27.1237 24ZM25.4691 18.5791V18.5626C25.4691 17.1828 26.5052 16.3121 28.4072 16.1807L32.1495 15.9343V17.2485C32.1495 19.3183 30.4794 20.8788 28.268 20.8788C26.5825 20.8788 25.4691 20.0082 25.4691 18.5791Z",
    fill: "#636363"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgText);
export default __webpack_public_path__ + "static/media/text.96a3b97e.svg";
export { ForwardRef as ReactComponent };